import React, { memo } from 'react';
import { Resizable } from 're-resizable';
import { Content } from './styles';

const CustomMarkForView = ({ selected, id, data }) => {
  return (
    <Resizable
      onClick={() => console.log('ok')}
      style={{ userSelect: 'none', cursor: 'auto' }}
      draggable={false}
      size={{ width: data.refData.width, height: data.refData.height }}
      enable={false}
      handleClasses={{
        top: 'nodrag',
        right: 'nodrag',
        bottom: 'nodrag',
        left: 'nodrag',
        topRight: 'nodrag',
        bottomRight: 'nodrag',
        bottomLeft: 'nodrag',
        topLeft: 'nodrag',
      }}
    //handleStyles={handleStyles}
    >
      <Content
        style={{
          background: data.hexColor,
          userSelect: 'none',
        }}
        className="nodrag"
      ></Content>
    </Resizable>
  );
};

export default memo(CustomMarkForView);
